import { createAction, props } from '@ngrx/store';
import { GameSession } from '../../models/game.model';

export const setCurrentSession = createAction(
  '[Game Session] Set Current Session',
  props<{ session: GameSession | null }>()
);

export const clearCurrentSession = createAction(
  '[Game Session] Clear Current Session'
);
